import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AlertBlock16Icon extends BaseIcon {
  getChildren = () => [
    <path fill={ this.getColor() }
          d="M8 2c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6m0-2C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8z"/>,
    <path transform="rotate(45 8.00012 7.99995)" fill={ this.getColor() } d="M.8 7h14.4v2H.8z"/>
    ]
  getViewBox = () => '0 0 16 16'
}
